<div
  class="calendar-header-container"
  [ngClass]="headerClassNames"
  id="multi-datepicker-multi-calendar-header-container"
>
  <div class="left-calendar-header-content" id="multi-datepicker-left-header-content">
    <button
      mat-icon-button
      class="multiple-calendar-navigation-button-icon"
      [id]="'prev-month-button-icon'"
      [disabled]="disablePrevNavButton"
      (click)="previousMonthClicked()"
    >
      <app-icon
        [name]="'keyboard_arrow_left'"
        [size]="'24px'"
        id="multi-datepicker-prev-button-icon"
      >
      </app-icon>
    </button>

    <span
      class="multiple-date-picker-month-label"
      id="multi-datepicker-prev-button-month"
    >
      {{ startActiveDate | date: formatterTemplate.display.monthLabel }}
    </span>
  </div>

  <div
    class="right-calendar-header-content"
    [id]="'right-calendar-picker-content-header'"
    [ngClass]="contentClassNames"
  >
    <div class="nav-month-button" id="multi-datepicker-right-content-button-wrapper">
      <span
        class="multiple-date-picker-month-label"
        id="multi-datepicker-next-button-month"
      >
        {{ endActiveDate | date: formatterTemplate.display.monthLabel }}
      </span>

      <button
        mat-icon-button
        class="multiple-calendar-navigation-button-icon"
        [id]="'next-month-button-icon'"
        [disabled]="disableNextNavButton"
        (click)="nextMonthClicked()"
      >
        <app-icon
          [name]="'keyboard_arrow_right'"
          [size]="'24px'"
          id="multi-datepicker-next-button-icon"
        >
        </app-icon>
      </button>
    </div>

    <button
      mat-button
      class="calendar-year-selection"
      [id]="'calendar-year-selection-button'"
      (click)="switchToYearMode()"
    >
      <span
        class="year-selection-label-button"
        id="multi-datepicker-year-selection-label"
      >
        {{ endActiveDate | date: formatterTemplate.display.yearLabel }}
        <app-icon
          [name]="'arrow_drop_down'"
          [size]="'24px'"
          id="multi-date-picker-year-selection-icon"
        >
        </app-icon>
      </span>
    </button>
  </div>
</div>

<ng-container *ngIf="showCentralBorder">
  <div class="central-splitter-devider" id="multi-datepicer-splitter-element"></div>
</ng-container>

<div class="calendars-content-container" id="multi-datepicker-calendar-content-container">
  <ng-container *ngIf="multiCalendarViewMode; else yearModeView">
    <ng-container *ngFor="let dateItem of datePickerPanels; let i = index">
      <div class="app-calendar-wrapper-item" id="multi-datepicker-calendar-wrapper-item">
        <mat-calendar
          [id]="'multi-datepicker-calendar-item-' + i"
          [startAt]="dateItem.date"
          [selected]="values"
          [dateFilter]="dateItem.dateFilter"
          [headerComponent]="calendarHeaderComponent"
          [dateClass]="customCellClasses"
          (selectedChange)="onChangeDates($event)"
        >
        </mat-calendar>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #yearModeView>
    <div
      class="multi-calendar-year-selections"
      id="multi-datepicker-calendar-year-view-wrapper"
    >
      <mat-calendar
        id="multi-datepicker-calendar-year-view"
        #yearCalendar
        [headerComponent]="calendarHeaderComponent"
        [startAt]="values"
        [minDate]="minDate"
        [maxDate]="maxDate"
        startView="multi-year"
        (monthSelected)="onYearModeChooseMonth($event)"
      >
      </mat-calendar>
    </div>
  </ng-template>
</div>
